import { IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

const styles: IStyles = {
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%',
    maxWidth: { xs: pxToRem(320), md: pxTovW(560) },
    paddingBottom: { xs: pxToRem(18), md: pxTovW(22) },
  },
  stepColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    zIndex: 2,
    minWidth: 0,
  },
  stepRing: {
    width: { xs: pxToRem(22), md: pxTovW(32) },
    height: { xs: pxToRem(22), md: pxTovW(32) },
    borderRadius: '50%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  stepInnerDot: {
    width: { xs: pxToRem(10), md: pxTovW(16) },
    height: { xs: pxToRem(10), md: pxTovW(16) },
    borderRadius: '50%',
  },
  stepLabel: {
    position: 'absolute',
    top: { xs: pxToRem(28), md: pxTovW(40) },
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
    color: '#333333',
    pointerEvents: 'none',
    fontSize: { xs: pxToRem(10), md: pxTovW(14) },
    fontWeight: 400,
    fontFamily: 'Poppins',
  },
  connector: {
    flex: 1,
    height: { xs: pxToRem(2), md: pxTovW(3) },
    backgroundColor: '#007CDC',
    alignSelf: 'flex-start',
    marginTop: { xs: pxToRem(10), md: pxTovW(14.5) },
    marginX: { xs: pxToRem(6), md: pxTovW(8) },
    zIndex: 1,
  },
};

export interface ISteps {
  index: number;
  stepTitle: string;
  stepClickHandler: () => void;
  nextClickHandler?: () => void;
  stepButtonText?: string;
  disableStep: boolean;
  stepIconColor: string;
  disabledIconColor?: string;
}
interface IProps {
  steps: ISteps[];
  currentStep: number;
}

export const StepperComponent = (props: IProps) => {
  const { steps, currentStep } = props;

  return (
    <Box sx={styles.root}>
      {steps.map((step, i) => {
        const ringColor = step.disableStep
          ? step.disabledIconColor || '#B8E0FF'
          : step.stepIconColor;
        const isActive = i === currentStep;

        return (
          <React.Fragment key={i}>
            <Box
              sx={{
                ...styles.stepColumn,
                cursor: step.disableStep ? 'not-allowed' : 'pointer',
              }}
              onClick={() => {
                if (!step.disableStep) {
                  step.stepClickHandler();
                }
              }}
            >
              <Box
                sx={{
                  ...styles.stepRing,
                  border: {
                    xs: `${pxToRem(3)} solid ${ringColor}`,
                    md: `${pxTovW(4)} solid ${ringColor}`,
                  },
                }}
              >
                {isActive ? (
                  <Box
                    sx={{
                      ...styles.stepInnerDot,
                      backgroundColor: ringColor,
                    }}
                  />
                ) : null}
              </Box>
              <Typography variant="caption" sx={styles.stepLabel}>
                {step.stepTitle}
              </Typography>
            </Box>
            {i < steps.length - 1 && <Box sx={styles.connector} />}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

// ...existing code...
// ...existing code...
// import React, { useState } from 'react';

// import { Box, Button, Paper, Typography } from '@mui/material';
// import Check from '@mui/icons-material/Check';
// export const StepperComponent = () => {
//   const [currentStep, setCurrentStep] = useState(0);
//   const totalSteps = 2;

//   const handleStepClick = (stepIndex: number) => {
//     if (stepIndex <= currentStep + 1) {
//       setCurrentStep(stepIndex);
//     }
//   };

//   const StepCircle = ({
//     index,
//     isCompleted,
//     isActive,
//   }: {
//     index: number;
//     isCompleted: boolean;
//     isActive: boolean;
//   }) => (
//     <Box
//       role="button"
//       tabIndex={0}
//       onClick={() => handleStepClick(index)}
//       onKeyDown={(e) => e.key === 'Enter' && handleStepClick(index)}
//       sx={{
//         width: 48,
//         height: 48,
//         borderRadius: '50%',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         cursor: 'pointer',
//         transition: 'all 0.3s ease',
//         position: 'relative',
//         bgcolor: isCompleted
//           ? 'primary.main'
//           : isActive
//           ? 'primary.light'
//           : 'grey.300',
//         boxShadow: 3,
//         '&:hover': {
//           transform: 'scale(1.1)',
//         },
//       }}
//       aria-label={`Step ${index + 1} ${
//         isCompleted ? 'completed' : isActive ? 'current' : 'pending'
//       }`}
//     >
//       {isCompleted ? (
//         <Check style={{ color: 'white', fontSize: 20 }} />
//       ) : (
//         <Typography
//           variant="body1"
//           sx={{ color: isCompleted || isActive ? 'white' : 'grey.700' }}
//         >
//           {index + 1}
//         </Typography>
//       )}
//       <Typography
//         variant="caption"
//         sx={{ position: 'absolute', bottom: -24, color: 'grey.600' }}
//       >
//         Step {index + 1}
//       </Typography>
//     </Box>
//   );

//   const StepConnector = ({
//     isCompleted,
//     isPartial,
//   }: {
//     isCompleted: boolean;
//     isPartial: boolean;
//   }) => (
//     <Box
//       sx={{
//         position: 'relative',
//         width: 96,
//         height: 8,
//         mx: 1,
//       }}
//     >
//       <Box
//         sx={{
//           position: 'absolute',
//           inset: 0,
//           bgcolor: 'grey.300',
//           borderRadius: 4,
//         }}
//       />
//       <Box
//         sx={{
//           position: 'absolute',
//           inset: 0,
//           bgcolor: 'primary.main',
//           width: isCompleted ? '100%' : isPartial ? '50%' : '0%',
//           borderRadius: 4,
//           transition: 'width 0.3s ease',
//         }}
//       />
//     </Box>
//   );

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//       }}
//     >
//       {Array.from({ length: totalSteps }).map((_, index) => (
//         <React.Fragment key={index}>
//           <StepCircle
//             index={index}
//             isCompleted={index < currentStep}
//             isActive={index === currentStep}
//           />
//           {index < totalSteps - 1 && (
//             <StepConnector
//               isCompleted={index < currentStep - 1}
//               isPartial={index === currentStep - 1}
//             />
//           )}
//         </React.Fragment>
//       ))}
//     </Box>
//   );
// };
